/**
 * Single source of truth for client-side temporary IDs.
 *
 * Used for optimistic-send `tmp-...` ids, file-upload slot ids, and any
 * other place where we need a sortable-ish unique key before the server
 * hands us a real one. Centralising avoids the previous drift where
 * three call-sites each had their own `${Date.now()}-${Math.random()...}`
 * variants — easy to break in a future migration.
 *
 *   tempId()           → "1f4a2c0b3-tx9j5q"
 *   tempId('msg')      → "msg-1f4a2c0b3-tx9j5q"
 *
 * Pure: no shared state, no monotonic counter (the timestamp prefix
 * preserves rough creation-order for sorting without needing one).
 */
export function tempId(prefix?: string): string {
  const body =
    typeof crypto !== 'undefined' && 'randomUUID' in crypto
      ? crypto.randomUUID()
      : `${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
  return prefix ? `${prefix}-${body}` : body;
}
